import { createFileRoute } from '@tanstack/react-router';
import { JobsPage } from '@/features/operator/jobs-page';

export const Route = createFileRoute('/operator/jobs')({
    staticData: { crumbs: [{ label: 'shell.operatorConsole', to: '/operator' }, { label: 'operator.nav.jobs' }] },
    component: JobsPage,
});
